var map = {
	"./7bank.png": 82425,
	"./DU.png": 51343,
	"./Kejora.png": 36968,
	"./Signum.png": 48323,
	"./UOB.png": 24898,
	"./elip.png": 17198,
	"./everest.png": 66904,
	"./hanwha.png": 96771,
	"./hashkey.png": 51937,
	"./inception.png": 57269,
	"./kybernet.png": 94750,
	"./lightnet.png": 33279,
	"./unipresident.png": 26620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71565;